export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Favorites-Gray-da9b72beaafba463371679c5e07bcac9.svg";